/* Cat Playpen Ball — store interactions. Self-contained; never touches Shrine's commerce elements. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onVisible(el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } });
    }, opts || { threshold: 0.35 });
    io.observe(el);
  }

  /* reveal */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.rm-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* hero colourway swatches */
  function initSwatches(root) {
    (root || document).querySelectorAll('.rm-hero').forEach(function (hero) {
      var stage = hero.querySelector('[data-rm-stage]');
      var buy = hero.querySelector('[data-rm-buy]');
      hero.querySelectorAll('.rm-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          hero.querySelectorAll('.rm-swatch').forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true');
          if (stage) stage.style.setProperty('--rm-ball', btn.getAttribute('data-color'));
          var img = stage && stage.querySelector('.rm-media__img');
          var src = btn.getAttribute('data-img');
          if (img && src) { img.removeAttribute('srcset'); img.setAttribute('src', src); }
          var url = btn.getAttribute('data-url');
          if (buy && url) buy.setAttribute('href', url);
        });
      });
    });
  }

  /* rails with arrows + wrap-around */
  function initRails(root) {
    (root || document).querySelectorAll('[data-rm-rail]').forEach(function (rail) {
      if (rail.__rm) return; rail.__rm = true;
      var section = rail.closest('.rm') || rail;
      var track = rail.querySelector('[data-rm-track]');
      if (!track) return;
      function step() {
        var item = track.children[0];
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
        return item.getBoundingClientRect().width + gap;
      }
      function scrollable() { return track.scrollWidth - track.clientWidth > 4; }
      function go(dir) {
        if (!scrollable()) return;
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        if (dir > 0 && x >= max - 4) { track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
        if (dir < 0 && x <= 4) { track.scrollTo({ left: max, behavior: reduce ? 'auto' : 'smooth' }); return; }
        track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      }
      section.querySelectorAll('[data-rm-prev]').forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
      section.querySelectorAll('[data-rm-next]').forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
    });
  }

  /* before / after */
  function initBA(root) {
    (root || document).querySelectorAll('[data-rm-ba]').forEach(function (ba) {
      if (ba.__rm) return; ba.__rm = true;
      var range = ba.querySelector('.rm-ba__range');
      function set(v) { ba.style.setProperty('--pos', v + '%'); }
      range.addEventListener('input', function () { set(range.value); ba.dataset.touched = '1'; });
      if (reduce) return;
      onVisible(ba, function () {
        if (ba.dataset.touched) return;
        var t0 = null, from = 50;
        function frame(t) {
          if (ba.dataset.touched) return;
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 2200);
          var v = from + Math.sin(p * Math.PI * 2) * 30 * (1 - p * .4);
          if (p >= 1) v = 50;
          set(v.toFixed(1)); range.value = v;
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      }, { threshold: 0.5 });
    });
  }

  /* pop demo */
  function initPop(root) {
    (root || document).querySelectorAll('[data-rm-pop]').forEach(function (stage) {
      if (stage.__rm) return; stage.__rm = true;
      var section = stage.closest('.rm');
      var btn = stage.querySelector('[data-rm-pop-btn]');
      var steps = section ? section.querySelectorAll('.rm-pop__step') : [];
      function mark(i) { steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); }); }
      function setState(open) {
        stage.setAttribute('data-state', open ? 'open' : 'flat');
        btn.setAttribute('aria-pressed', open ? 'true' : 'false');
        mark(open ? Math.min(1, steps.length - 1) : 0);
        if (open && steps.length > 2) { clearTimeout(stage.__t); stage.__t = setTimeout(function () { if (stage.getAttribute('data-state') === 'open') mark(2); }, 1300); }
      }
      mark(0);
      btn.addEventListener('click', function () { stage.dataset.touched = '1'; setState(stage.getAttribute('data-state') !== 'open'); });
      onVisible(stage, function () { if (!stage.dataset.touched) setTimeout(function () { if (!stage.dataset.touched) setState(true); }, reduce ? 0 : 700); }, { threshold: 0.6 });
    });
  }

  /* fit checker */
  function initFit(root) {
    (root || document).querySelectorAll('[data-rm-fit]').forEach(function (fit) {
      if (fit.__rm) return; fit.__rm = true;
      var range = fit.querySelector('[data-rm-fit-range]');
      var out = fit.querySelector('[data-rm-fit-out]');
      var msg = fit.querySelector('[data-rm-fit-msg]');
      var cat = fit.querySelector('[data-rm-fit-cat]');
      var line = fit.querySelector('[data-rm-fit-line]');
      var D = parseFloat(fit.getAttribute('data-diameter')) || 68;
      var pxPerCm = 340 / D;           /* ball is drawn 340 px across */
      var catLen = 152;                /* silhouette: tail base (-56) to nose (96) */
      function update() {
        var L = parseFloat(range.value);
        var s = (L * pxPerCm) / catLen;
        var feet = 334;
        /* centre the body (tail base..nose) horizontally in the ball */
        var cx = 200 - ((-56 + 96) / 2) * s;
        cat.setAttribute('transform', 'translate(' + cx.toFixed(1) + ' ' + feet + ') scale(' + s.toFixed(3) + ' ' + (s * 0.8).toFixed(3) + ') translate(-200 -318)');
        var y = feet - 112 * s * 0.8;
        line.setAttribute('x1', (cx + (-56) * s).toFixed(1)); line.setAttribute('x2', (cx + 96 * s).toFixed(1));
        line.setAttribute('y1', y.toFixed(1)); line.setAttribute('y2', y.toFixed(1));
        out.textContent = L + ' cm';
        var r = L / D, level;
        if (r <= 0.66) level = 'roomy'; else if (r <= 0.8) level = 'fits'; else if (r <= 0.91) level = 'snug'; else level = 'tight';
        var pct = (fit.getAttribute('data-pct-label') || '').replace('[pct]', Math.round(r * 100));
        msg.textContent = (pct ? pct + ' ' : '') + fit.getAttribute('data-msg-' + level);
        msg.setAttribute('data-level', level);
        range.style.setProperty('--fill', ((L - range.min) / (range.max - range.min) * 100) + '%');
      }
      range.addEventListener('input', update);
      update();
    });
  }

  /* tabs */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-rm-tabs]').forEach(function (tabs) {
      if (tabs.__rm) return; tabs.__rm = true;
      var list = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        list.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
        if (tab.scrollIntoView && window.innerWidth < 990) {
          var l = tab.parentElement; l.scrollTo({ left: tab.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      list.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') n = list[(i + 1) % list.length];
          if (k === 'ArrowLeft' || k === 'ArrowUp') n = list[(i - 1 + list.length) % list.length];
          if (k === 'Home') n = list[0];
          if (k === 'End') n = list[list.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* checklist */
  function initRules(root) {
    (root || document).querySelectorAll('[data-rm-rules]').forEach(function (wrap) {
      if (wrap.__rm) return; wrap.__rm = true;
      var boxes = wrap.querySelectorAll('.rm-rule__box');
      var count = wrap.querySelector('[data-rm-rules-count]');
      var bar = wrap.querySelector('[data-rm-rules-bar]');
      var done = wrap.querySelector('[data-rm-rules-done]');
      function update() {
        var n = 0; boxes.forEach(function (b) { if (b.checked) n++; });
        count.textContent = n;
        bar.style.width = (boxes.length ? n / boxes.length * 100 : 0) + '%';
        done.hidden = n !== boxes.length;
      }
      boxes.forEach(function (b) { b.addEventListener('change', update); });
      update();
    });
  }

  /* closing CTA → buy box on the product page */
  function initScrollBuy(root) {
    (root || document).querySelectorAll('[data-rm-scrollbuy]').forEach(function (a) {
      if (a.__rm) return; a.__rm = true;
      a.addEventListener('click', function (e) {
        var target = document.querySelector('[id^="ProductInfo-"]');
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function init(root) {
    initReveal(root); initSwatches(root); initRails(root); initBA(root); initPop(root);
    initFit(root); initTabs(root); initRules(root); initScrollBuy(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
